import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  Zoom,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LaunchIcon from '@mui/icons-material/Launch';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

interface DownloadAppDialogProps {
  open: boolean;
  onClose: () => void;
}

const DownloadAppDialog: React.FC<DownloadAppDialogProps> = ({ open, onClose }) => {
  const handleDownloadClick = () => {
    const downloadUrl =
      'https://play.google.com/store/apps/details?id=com.darukaa.ritva&pcampaignid=web_share';
    window.open(downloadUrl, '_blank');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Zoom}
      aria-labelledby="download-app-dialog-title"
      maxWidth="xs"
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          borderRadius: 4,
          p: 0,
          backgroundColor: '#0D0D0D',
          border: '1px solid #222',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4)',
          overflow: 'hidden',
        },
      }}
    >
      <Box 
        sx={{ 
          height: '140px', 
          background: 'linear-gradient(135deg, #10B981 0%, #064E3B 100%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          color: '#fff',
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            color: 'rgba(255, 255, 255, 0.7)',
            '&:hover': {
              color: '#fff',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
        <RocketLaunchIcon sx={{ fontSize: 48, mb: 1, opacity: 0.9 }} />
        <Typography variant="h5" sx={{ fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1.5 }}>
          New Arrival!
        </Typography>
      </Box>

      <DialogTitle id="download-app-dialog-title" sx={{ textAlign: 'center', pt: 4, pb: 1 }}>
        <Typography variant="h4" sx={{ fontWeight: 800, color: '#FFF', fontSize: '1.75rem' }}>
          Take a look at our new app!
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pb: 3, textAlign: 'center', px: 4 }}>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ color: '#999', fontSize: '1.1rem', lineHeight: 1.6 }}
        >
          Nature at Your Fingertips. <br />
          Experience seamless biodiversity monitoring and environmental insights anywhere, anytime.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 5, px: 4 }}>
        <Button
          onClick={handleDownloadClick}
          variant="contained"
          fullWidth
          size="large"
          startIcon={<LaunchIcon />}
          sx={{
            py: 2,
            borderRadius: 2,
            backgroundColor: '#10B981',
            color: '#000',
            fontWeight: 800,
            fontSize: '1.1rem',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#059669',
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
          }}
        >
          Download the app
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadAppDialog;
